import {NgModule} from '@angular/core';
import {SubmitButtonComponent} from "@iw-shop/forms/components/submit-button/submit-button.component";
import {NgClass} from "@angular/common";
import {DebounceClickDirective} from "@iw-shop/core/directives/debounce-click.driective";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormErrorComponent} from "@iw-shop/forms/components/error/form-error.component";

@NgModule({
    declarations: [
        SubmitButtonComponent,
        DebounceClickDirective
    ],
    imports: [
        NgClass,
        FontAwesomeModule,
        FormErrorComponent
    ],
    exports: [
        SubmitButtonComponent
    ]
})
export class MyFormsModule {
}
